import api from './api';
import { Workation, WorkationCreate } from '../types';

export const workationService = {
  list: async (jahr?: number): Promise<Workation[]> => {
    const params: Record<string, unknown> = {};
    if (jahr) params.jahr = jahr;
    const response = await api.get('/workation/', { params });
    return response.data;
  },

  listAlle: async (jahr?: number, status?: string): Promise<Workation[]> => {
    const params: Record<string, unknown> = {};
    if (jahr) params.jahr = jahr;
    if (status) params.status = status;
    const response = await api.get('/workation/alle', { params });
    return response.data;
  },

  create: async (data: WorkationCreate): Promise<Workation> => {
    const response = await api.post('/workation/', data);
    return response.data;
  },

  update: async (id: number, data: Partial<WorkationCreate>): Promise<Workation> => {
    const response = await api.put(`/workation/${id}`, data);
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(`/workation/${id}`);
  },

  genehmigen: async (id: number, adminBemerkung?: string): Promise<Workation> => {
    const response = await api.put(`/workation/${id}/genehmigen`, {
      admin_bemerkung: adminBemerkung || null,
    });
    return response.data;
  },

  ablehnen: async (id: number, adminBemerkung?: string): Promise<Workation> => {
    const response = await api.put(`/workation/${id}/ablehnen`, {
      admin_bemerkung: adminBemerkung || null,
    });
    return response.data;
  },
};
